export default __webpack_public_path__ + "2bc4c9df95cf09480c8b5a87db2e3843.png";